/**
 * 移动端路由
 */
export default [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '家居正品查询平台-手机官网'
    },
    component: () =>
        import('@/views/mobile/home')
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      title: '搜索'
    },
    component: () =>
        import('@/views/mobile/search')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    meta: {
      title: '联系我们'
    },
    component: () =>
        import('@/views/mobile/contactUs')
  },
  {
    path: '/classify',
    name: 'classify',
    meta: {
      title: '分类'
    },
    component: () =>
        import('@/views/mobile/classify')
  },
  {
    path: '/brands',
    name: 'brands',
    meta: {
      title: '品牌'
    },
    component: () =>
        import('@/views/mobile/brands')
  },
  {
    path: '/brandDetail',
    name: 'brandDetail',
    meta: {
      title: '品牌详情'
    },
    component: () =>
        import('@/views/mobile/brandDetail')
  },
  {
    path: '/newsList',
    name: 'newsList',
    meta: {
      title: '新闻中心'
    },
    component: () =>
        import('@/views/mobile/newsList')
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    meta: {
      title: '新闻详情'
    },
    component: () =>
        import('@/views/mobile/newsDetail')
  }
]



// WEBPACK FOOTER //
// ./src/router/mobile.js